module.exports = "\n<div class=\"tg-loadding\">\n    <div class=\"tg-loaddingInner\">\n    \tLoading...\n    </div>\n</div>\n";